
<template>
  <v-container class="grey lighten-5">
    <div class="mb-5">
      <!-- <v-btn icon :to="{ path: '/' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn> -->
      <div class="display-1 px-3">ご利用マニュアル</div>
    </div>
    <v-row dense>
      <v-col :cols="manCols" dense>
        <v-card class="pa-4">
        <v-btn text x-small @click="$router.back()" class="grey--text">
          <v-icon>mdi-arrow-left</v-icon>
          戻る
        </v-btn>
          <router-view></router-view>
          <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
            <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
          </v-overlay>
        <v-btn text x-small @click="$vuetify.goTo(number, scrollOptions)" class="grey--text">
          <v-icon>mdi-arrow-up</v-icon>
          トップに戻る
        </v-btn>

        </v-card>
      </v-col>
      <v-col :cols="manCols2" transition="scroll-y-transition"
>
        <v-card flat class="pa-4">
          <v-list>
            <div v-show="!isManualHide">
              <v-btn text x-small @click="manHide" class="grey--text">
                <span>隠す</span>
                <v-icon>mdi-arrow-collapse-right</v-icon>
              </v-btn>
            </div>

            <div v-show="isManualHide">
              <v-btn text x-small @click="manHide" class="grey--text">
                <v-icon>mdi-arrow-collapse-left</v-icon>
                <span>表示</span>
              </v-btn>
            </div>

            <v-subheader>目次</v-subheader>
            <!-- <v-list-item-group color="primary"> -->
              <v-list-item
                v-for="(item, i) in contents"
                :key="i"
                v-show="!isManualHide"
                @click="showMan(item.id)"
              >
                <v-list-item-icon>
                  <v-icon small color="primary" v-text="item.icon"></v-icon>
                </v-list-item-icon>
                  <v-list-item-content
                   class="body-2" 
                   v-text="item.text"
                   >
                  </v-list-item-content>
              </v-list-item>
            <!-- </v-list-item-group> -->
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as easings from 'vuetify/es5/services/goto/easing-patterns'

export default {
  name: 'usermanual',
  data() {
    return {
      overlayStepper1: true,
      isManualHide: false,
      manCols: 8,
      manCols2: 4,
      number: 1,
      duration: 300,
      offset: 0,
      easing: 'easeInOutCubic',
      easings: Object.keys(easings),      
      content: 'isEntryFlow',
      beforeContent: 'isEntryFlow',
      contents: [
        { text: 'お申込みの流れ', icon: "mdi-file-document", id: "", content:0 },
        { text: 'マイ機器の登録/更新/削除', icon: 'mdi-file-document', id: "manMyMachineEdit",content:1 },
        { text: 'マイ機器QRコードを印刷する', icon: 'mdi-file-document', id: "manMyMachineQrPrint",content:2 },
        { text: '分析サンプルを採取登録する', icon: 'mdi-file-document', id: "manSampleEntry", content:3 },
        { text: '分析を依頼する', icon: 'mdi-file-document', id: "manAnalizeEntry", content:4 },
        { text: '申し込み履歴を確認する', icon: 'mdi-file-document', id: "manEntryConfirm" ,content:5},
        { text: '申し込み書を印刷する', icon: 'mdi-file-document', id: "manEntryPrint", content:6 },
        { text: '分析サンプル貼り付け用バーコードシートを印刷する', icon: 'mdi-file-document', id: "manSampleQrPrint", content:7 },
        { text: '担当者一覧を確認する', icon: 'mdi-file-document', id: "manEmployeeConfirm",content:8 },
        { text: '担当者へサービスの利用を許可する', icon: 'mdi-file-document', id: "manEmployeeGrant", content:9 },
        { text: '担当者の権限を変更する', icon: 'mdi-file-document', id: "manEmployeeAuth", content:10 },
      ],      
    }
  },
  mounted: async function () {
      this.overlayStepper1=false
  },
  computed : {
  },
  methods: {
    showMan: async function (value) {
      this.overlayStepper1=true
      var url = '/UserManual/' + value
      this.$router.push(url)
      this.overlayStepper1=false
    },
    manHide: async function () {
      if (this.isManualHide) {
        this.isManualHide = false
        this.manCols=8
        this.manCols2=4

      } else {
        this.isManualHide = true
        this.manCols=11
        this.manCols2=1
       
      }
    },
    scrollOptions: async function () {
        return {
          duration: this.duration,
          offset: this.offset,
          easing: this.easing,
        }
    }
  },
}
</script>